export default __webpack_public_path__ + "static/media/logo.d95a049d.svg";